import React, { useState } from "react";
import styles from "./ActiveRentProgContainer.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { ClipLoader } from "react-spinners";
import { ErrorComponent } from "../ErrorComponent/ErrorComponent";
import Title from "../../ui/Title/Title";
import RentProgIcon from "../../assets/icons/RentProgIcon";
import { useNavigate } from "react-router-dom";
import { TrashIcon } from "../../assets/icons/TrashIcon";
import { deleteIntegrationRentProg } from "../../utils/api/actions/integrations/rentProg";

export const ActiveRentProgContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeDataRentProg, isLoadingRentProg } = useSelector(
    (state) => state?.rentProg
  );

  const [errorRentProg] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    let data = {
      id: activeDataRentProg?.id,
    };
    dispatch(deleteIntegrationRentProg(data, setLoading, navigate));
  };

  const DataItem = ({ title, data }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
        </div>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  const maskString = (str, startVisible = 6, endVisible = 4) => {
    if (!str || str.length <= startVisible + endVisible) {
      return str;
    }

    const visibleStart = str.slice(0, startVisible);
    const visibleEnd = str.slice(-endVisible);
    const maskedPart = "*".repeat((str.length - startVisible - endVisible) / 2);

    return `${visibleStart}${maskedPart}${visibleEnd}`;
  };

  const actions = [
    {
      className: styles.deleteButton,
      titleClassName: styles.titleDeleteButton,
      title: loading ? "Подождите" : "Удалить",
      icon: loading ? (
        <ClipLoader color="#cb3e3e" size={16} />
      ) : (
        <TrashIcon width={16} height={18} fill={"#cb3e3e"} />
      ),
      onClick: handleDelete,
    },
  ];

  return (
    <div className={styles.container}>
      <ScreenHeader
        title={"Интеграции"}
        path={"/integration"}
        actions={actions}
      />
      {isLoadingRentProg ? (
        <div className={styles.loaderContainer}>
          <ClipLoader color="#3e8fcb" size={90} />
          <div>Загрузка данных</div>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerInfoContainer}>
              {!errorRentProg && (
                <div className={styles.headerInfoContainerTitle}>
                  <Title
                    title={"Интеграция с RentProg"}
                    className={styles.title}
                  />
                  <RentProgIcon />
                </div>
              )}
              {errorRentProg && (
                <ErrorComponent
                  title={"Произошла ошибка при получении данных RentProg"}
                  text={
                    "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
                  }
                  buttonTitle={"Вернуться на страницу интеграций"}
                  path={"/integration"}
                />
              )}
            </div>
          </div>

          {activeDataRentProg && !errorRentProg && (
            <>
              <div className={styles.rowData}>
                <DataItem
                  title={"Токен доступа"}
                  data={maskString(activeDataRentProg?.companyToken, 4, 5)}
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
